import React from 'react';

import { Box, Typography } from '@material-ui/core';

import phoneImage from '@motusi/assets/img/phone.png';
import appStoreImage from '@motusi/assets/img/app-store.png';
import MotusiTitle from '@motusi/app/modules/common-ui/components/MotusiTitle';
import Router from '@motusi/app/modules/core/routing/Router';
import { AUTH_ROUTES } from '@motusi/app/modules/core/routing/routes/auth.routes';

import { useAuthStyles } from './style';

// Component
const Auth = () => {
  const classes = useAuthStyles();

  return (
    <Box className={classes.container}>
      <Router routes={AUTH_ROUTES} />

      <Box style={{ display: 'grid', gridTemplateColumns: '47% 53%' }}>
        <Box>
          <MotusiTitle>JOIN MOTUSI</MotusiTitle>
          <Typography className={classes.text}>
            Download the Motusi app to Get started and Create your member account
          </Typography>
          <a href="/">
            <img src={appStoreImage} style={{ marginTop: 35 }} alt="App Store Link" />
          </a>
        </Box>
        <Box>
          <img src={phoneImage} className={classes.phone} alt="App Store Link" />
        </Box>
      </Box>
    </Box>
  );
};

export default Auth;
